module.exports = __webpack_public_path__ + "img/back buttons quantity.2af007b0.png";